<template>
    <el-empty description="Ei tietoja"></el-empty>
</template>
